import { FilterCondition, FilterGroup, ProspectFilterField } from '../types';
import { FilterGroupLogicPayload } from '../../../types';

type ConstructFilterGroupFromPayload = {
  filterGroups: FilterGroupLogicPayload;
  fields: ProspectFilterField[];
};

export const constructFilterGroupFromPayload = ({
  fields,
  filterGroups,
}: ConstructFilterGroupFromPayload): FilterGroup[] => {
  const groupedFilters: { [key: number]: FilterGroup } = {};

  filterGroups.filters.forEach((filter) => {
    // Initialize the group if it doesn't exist
    if (!groupedFilters[filter.group]) {
      groupedFilters[filter.group] = {
        group: filter.group,
        logic: filter.logic,
        conditions: [],
      };
    }

    // Map each condition from input filters to the desired structure
    filter.conditions.forEach((condition) => {
      const field = fields.find(
        (f) =>
          f?.key === condition.field || f?.id?.toString() === condition.field,
      );

      if (field) {
        const newCondition: FilterCondition = {
          field,
          operation: condition.operation,
          value: condition.value ?? undefined, // If no value exists, set to undefined
        };

        // Add the new condition to the respective group
        groupedFilters[filter.group].conditions.push(newCondition);
      } else {
        const newCondition: FilterCondition = {
          field: {
            id: condition.field,
            key: condition.field,
            label: condition.field,
            operations: [condition.operation],
            source: condition.source,
            value: condition.field,
          },
          operation: condition.operation,
          value: condition.value ?? undefined, // If no value exists, set to undefined
        };

        // Add the new condition to the respective group
        groupedFilters[filter.group].conditions.push(newCondition);
      }
    });
  });

  // Convert the groupedFilters object into an array of FilterGroup[]
  return Object.values(groupedFilters);
};
